import { jsxs as e, jsx as i, Fragment as S } from "react/jsx-runtime";
import y from "../LeadForm/LeadForm.js";
import { validationSchemaIsLogged as N, validationSchema as k } from "./validations.js";
import "@material-ui/core/Box";
import v from "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import x from "@material-ui/core/Dialog";
import I from "@material-ui/core/DialogActions";
import L from "@material-ui/core/DialogContent";
import w from "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import l from "@material-ui/core/Grid";
import C from "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import D from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import F from "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import M from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import V from "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import W from "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { normalizePhoneNumber as j } from "@propify-tenant-client/common";
import { Formik as A } from "formik";
const B = D({
  dialog: {
    position: "relative"
  },
  close: {
    position: "absolute",
    top: 0,
    right: 0
  },
  title: {
    textAlign: "center"
  }
}), T = ({ classes: o, isLogged: n, onClose: r, onSubmit: a, open: p, width: c, login: s }) => {
  const d = (t, m) => {
    a({ ...t, phone: j(t.phone) }), r(), m.setSubmitting(!1);
  }, h = (t) => {
    t.stopPropagation();
  }, u = ["xs", "sm"].includes(c), f = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  }, g = { message: "" };
  return /* @__PURE__ */ e(
    x,
    {
      open: p,
      onClose: r,
      fullScreen: u,
      className: o.dialog,
      onClick: h,
      fullWidth: !0,
      children: [
        /* @__PURE__ */ i(w, { className: o.title, children: /* @__PURE__ */ e(l, { container: !0, justify: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ i(M, { variant: "h6", children: "Add yourself to our waiting list" }),
          /* @__PURE__ */ i(
            C,
            {
              edge: "start",
              color: "inherit",
              onClick: r,
              "aria-label": "close",
              className: o.close,
              children: /* @__PURE__ */ i(W, {})
            }
          )
        ] }) }),
        /* @__PURE__ */ i(
          A,
          {
            initialValues: n ? g : f,
            onSubmit: d,
            validationSchema: n ? N : k,
            children: (t) => {
              const { isValid: m, handleSubmit: b } = t;
              return /* @__PURE__ */ e(S, { children: [
                /* @__PURE__ */ i(L, { children: /* @__PURE__ */ i("form", { onSubmit: b, children: /* @__PURE__ */ i(l, { container: !0, spacing: 2, children: /* @__PURE__ */ i(y, { formProps: t, login: s }) }) }) }),
                /* @__PURE__ */ i(I, { children: /* @__PURE__ */ i(
                  v,
                  {
                    variant: "contained",
                    color: "primary",
                    fullWidth: !0,
                    disabled: !m,
                    type: "button",
                    onClick: () => t.handleSubmit(),
                    children: "Submit"
                  }
                ) })
              ] });
            }
          }
        )
      ]
    }
  );
}, Ti = V()(F(B, { name: "LeadModal" })(T));
export {
  Ti as default
};
//# sourceMappingURL=LeadModal.js.map
